<template>
    <div>
        <label :for="uuid" class="block mb-2 text-sm font-medium" :class="reverseColor === true ? 'text-white' : 'text-gray-900'" v-if="label && label.length > 0">{{ label }}</label>
        <input :type="type" :id="uuid"
            class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" :placeholder="placeholder" :value="modelValue" @change="changeValue">
        <div class="text-red-500" v-if="$root.errors[name]">
            {{ $root.errors[name] }} 
        </div>
    </div>
</template>
<script>
export default {
    props: {
        name: {},
        label: {},
        type: {
            default: 'text',
        },
        placeholder: {
            default: '',
        },
        modelValue: {},
        fielderrors: {},

        reverseColor: {
            default: false,
        },
    },

    data() {
        return {
            uuid: this.generateUUID(),
        };
    },

    methods: {
        changeValue(e) {
            this.$emit('update:modelValue', e.target.value);
        }
    }
}
</script>